/**
 * External Dependencies
 */
import 'jquery';
// import { map } from 'jquery';
import 'rangeslider.js/dist/rangeslider.min.js';
import Swiper, { Navigation, Pagination } from 'swiper';

/*
global js_object_name
global ajax_cars_data
*/

$(document).ready(() => {
  Swiper.use([Pagination, Navigation]);
  dinamicSwiper();
  initSwiper();
  initAccordion();
  initMobileMenu();
  inputStepsPosition();
  modal();
  modalTabs();
  carSelect();
  checkInputLength();
  contactFormSucess();

  $('input[type="range"]').rangeslider({
    polyfill: false,
  });

  additionalServices();

  tooltipDescription();
  footerLangs();
  rentBtn();


  $("a[href*='#']:not([href='#'])").click(function (e) {
    if ($(this).hasClass('swiper-slide')) {
      return;
    }
    if ($(this).hasClass('auth')) {
      return;
    }

    e.preventDefault();
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      $('html,body').animate({
        scrollTop: target.offset().top - 80
      }, 1000);
      return false;
    }
  });

  const audio = document.getElementById("audio");
  document.addEventListener('wpcf7mailsent', function (event) {

    if (event.detail.contactFormId == '3115') {

      audio.play();
    }
    if (event.detail.contactFormId == '3135') {
      audio.play();
    }
    if (event.detail.contactFormId == '3141') {
      audio.play();
    }
  }, false);


});

$(window).on('resize', function () {
  initSwiper();
  inputStepsPosition();
});

let contentSwiper = undefined;
let carSwiper = undefined;
let singleCarSLider = undefined;
let soonCarSLider = undefined;
let innerCarSLider = undefined;


function dinamicSwiper() {
  if ($(".single-car-slider")[0]) {
    singleCarSLider = new Swiper('.single-car-slider', {
      loop: true,
      observer: true,
      pagination: {
        el: '.swiper-single-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

function initSwiper() {

  let screenWidth = window.innerWidth;
  if (screenWidth < 769 && contentSwiper == undefined) {
    if ($(".content-slider")[0]) {
      contentSwiper = new Swiper('.content-slider', {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
        },
      });
    }
  } else if (screenWidth > 769 && contentSwiper != undefined) {
    if (contentSwiper.length > 1) {
      contentSwiper.forEach(function (currentSwiper) {
        currentSwiper.destroy();
      });
    } else {
      contentSwiper.destroy();
    }
    contentSwiper = undefined;
    $('.swiper-wrapper').removeAttr('style');
    $('.swiper-slide').removeAttr('style');
  }
  if (screenWidth < 769 && carSwiper == undefined) {
    if ($(".slider-cars")[0]) {
      carSwiper = new Swiper('.slider-cars', {
        loop: true,
        slidesPerView: 1.1,
        spaceBetween: 12,
        breakpoints: {
          468: {
            slidesPerView: 2,
            spaceBetween: 20
          },
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });
    }
  } else if (screenWidth > 769 && carSwiper != undefined) {
    if (carSwiper.length > 1) {
      carSwiper.forEach(function (currentSwiper) {
        currentSwiper.destroy();
      });
    } else {
      carSwiper.destroy();
    }
    carSwiper = undefined;
    $('.swiper-wrapper').removeAttr('style');
    $('.swiper-slide').removeAttr('style');
  }

  if ($('.cars-slider-inner')[0]) {
    innerCarSLider = new Swiper('.cars-slider-inner', {
      // loop: true,
      navigation: {
        nextEl: '.swiper-button-next-soon',
        prevEl: '.swiper-button-prev-soon',
      },
      // observer: true,
      breakpoints: {
        2: {
          slidesPerView: 1.1,
          spaceBetween: 10
        },
        468: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        769: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    });
  }

  if (screenWidth < 769 && soonCarSLider == undefined) {
    if ($(".cars-slider-init")[0]) {
      soonCarSLider = new Swiper('.cars-slider-init', {
        loop: true,
        // observer: true,
        breakpoints: {
          2: {
            slidesPerView: 1.1,
            spaceBetween: 10
          },
          468: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          769: {
            slidesPerView: 4,
            spaceBetween: 20
          },
        },
      });
    }
  } else if (screenWidth > 769 && soonCarSLider != undefined) {
    if (soonCarSLider.length > 1) {
      soonCarSLider.forEach(function (currentSwiper) {
        currentSwiper.destroy();
      });
    } else {
      soonCarSLider.destroy();
    }
    soonCarSLider = undefined;
    $('.swiper-wrapper').removeAttr('style');
    $('.swiper-slide').removeAttr('style');
  }
}

function initAccordion() {
  const acc = document.getElementsByClassName("accordion");
  let i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      let panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
}

function initMobileMenu() {
  $('.burger-menu').on('click', function () {
    $('.nav-primary').toggleClass('open');
    $('body').toggleClass('opened');
  });
}

function inputStepsPosition() {

  const inputStepWrappers = $('.input-steps-wrapper');

  inputStepWrappers.each(function () {

    const childLength = $(this).children().length;
    const inputSliderWidth = $('.calculator-element-slider').width();

    $(this).children().each(function (index) {

      let leftInputPx = (index * (inputSliderWidth - 24)) / (childLength - 1);
      let spanWidth;

      if (index == 0) {
        spanWidth = +12;
      } else if (index === childLength - 1) {
        spanWidth = $(this).width() - 8;
      } else {
        spanWidth = (($(this).width()) / 2);
      }

      let leftCssPx = leftInputPx;
      let spanWidthPx = spanWidth;
      let position = (leftCssPx - spanWidthPx + 12) + 'px';
      $(this).css('left', position);

    });
  });
}


function modal() {
  const modal = document.getElementById("myModal");
  const modalConfiguration = document.getElementById("modalConfiguration");
  const modalSoon = document.getElementById("modalSoon");
  const modalNoCarsSoon = document.getElementById("modalNoCarsSoon");
  const modalServices = document.getElementById("modalServices");
  const modalMissingCar = document.getElementById("modalMissingCar");
  const modalRentDuration = document.getElementById("modalRentDuration");


  if (typeof modal == 'undefined') {
    return;

  }
  if (typeof modalConfiguration == 'undefined') {
    return;
  }
  if (typeof modalSoon == 'undefined') {
    return;
  }
  if (typeof modalNoCarsSoon == 'undefined') {
    return;
  }
  if (typeof modalMissingCar == 'undefined') {
    return;
  }
  if (typeof modalServices == 'undefined') {
    return;
  }
  if (typeof modalRentDuration == 'undefined') {
    return;
  }

  const span = document.getElementsByClassName("close")[0];
  const body = document.getElementsByTagName('body')[0]

  $('.btn-modal, #btnModal').on('click', function () {
    modal.style.display = "flex";
    body.style.overflow = "hidden";
    $('.header').css('z-index', '0');
    $('.nav-primary').removeClass('open');
    $('body').removeClass('opened');

    carDataForm();
  });

  $('#configuration-btn').on('click', function () {
    modalConfiguration.style.display = "flex";
    body.style.overflow = "hidden";
    $('.header').css('z-index', '0');
    $('.nav-primary').removeClass('open');
    $('body').removeClass('opened');
  });

  $('.soon-modal-btn').on('click', function () {
    modalSoon.style.display = "flex";
    body.style.overflow = "hidden";
    $('.header').css('z-index', '0');
    $('.nav-primary').removeClass('open');
    $('body').removeClass('opened');


    $("#form-car-model").val($(this).prev().find('.soon-car-box-title')[0].innerHTML);
  });

  $('.rent-modal-btn').on('click', function () {
    modalRentDuration.style.display = "flex";
    body.style.overflow = "hidden";
    $('.header').css('z-index', '0');
    $('.nav-primary').removeClass('open');
    $('body').removeClass('opened');
  });

  $('.no-cars-modal-btn').on('click', function () {
    modalNoCarsSoon.style.display = "flex";
    body.style.overflow = "hidden";
    $('.header').css('z-index', '0');
    $('.nav-primary').removeClass('open');
    $('body').removeClass('opened');
  });

  $('.missing-car-modal-btn').on('click', function () {
    modalMissingCar.style.display = "flex";
    body.style.overflow = "hidden";
    $('.header').css('z-index', '0');
    $('.nav-primary').removeClass('open');
    $('body').removeClass('opened');
  });


  $('span.close, .close-rent-modal').on('click', function () {
    modal.style.display = "none";
    // console.log('works');
    if (modalConfiguration) {
      modalConfiguration.style.display = "none";
    }
    if (modalSoon) {
      modalSoon.style.display = "none";
    }
    if (modalNoCarsSoon) {
      modalNoCarsSoon.style.display = "none";
    }
    if (modalMissingCar) {
      modalMissingCar.style.display = "none";
    }
    if (modalRentDuration) {
      modalRentDuration.style.display = "none";
    }
    body.style.overflow = "auto";
    $('.header').css('z-index', '1');

    $('#juridical .form-box').show();
    $('#juridical .form-box-success').hide();
  });

  window.onclick = function (event) {
    if (event.target == modal || event.target == modalConfiguration || event.target == modalSoon || event.target == modalRentDuration) {
      modal.style.display = "none";
      if (modalConfiguration) {
        modalConfiguration.style.display = "none";
      }
      if (modalSoon) {
        modalSoon.style.display = "none";
      }
      if (modalRentDuration) {
        modalRentDuration.style.display = "none";
      }
      body.style.overflow = "auto";
      $('.header').css('z-index', '1');
    }
  }
}

function modalTabs() {
  $('.modal-header-tab').on('click', function () {
    $('.modal-header-tab').removeClass('active');
    $(this).addClass('active');

    const targetId = $(this).attr('data-target');
    const allContent = $(`.modal-body`);

    allContent.children().each(function () {
      $('.modal-body-block').removeClass('active');
      $('#' + targetId).addClass('active');
    });

  });
}

function checkIcon(el) {
  let icon = '';
  if (el === 'Exterior') {
    icon = '<svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.4922 4.375H18.1875L17.5234 2.77344C16.8594 1.09375 15.2578 0 13.4609 0H8.5C6.70312 0 5.10156 1.09375 4.4375 2.77344L3.77344 4.375H1.46875C1.15625 4.375 0.921875 4.6875 1 4.96094L1.23438 5.89844C1.27344 6.13281 1.46875 6.25 1.70312 6.25H2.48438C1.9375 6.71875 1.625 7.38281 1.625 8.125V10C1.625 10.6641 1.85938 11.2109 2.25 11.6406V13.75C2.25 14.4531 2.79688 15 3.5 15H4.75C5.41406 15 6 14.4531 6 13.75V12.5H16V13.75C16 14.4531 16.5469 15 17.25 15H18.5C19.1641 15 19.75 14.4531 19.75 13.75V11.6406C20.1016 11.2109 20.375 10.6641 20.375 10V8.125C20.375 7.38281 20.0234 6.71875 19.4766 6.25H20.2969C20.4922 6.25 20.6875 6.13281 20.7266 5.89844L20.9609 4.96094C21.0391 4.6875 20.8047 4.375 20.4922 4.375ZM6.74219 3.71094C7.05469 2.96875 7.71875 2.5 8.5 2.5H13.4609C14.2422 2.5 14.9062 2.96875 15.2188 3.71094L16 5.625H6L6.74219 3.71094ZM4.75 10C3.96875 10 3.5 9.53125 3.5 8.75C3.5 8.00781 3.96875 7.5 4.75 7.5C5.49219 7.5 6.625 8.63281 6.625 9.375C6.625 10.1172 5.49219 10 4.75 10ZM17.25 10C16.4688 10 15.375 10.1172 15.375 9.375C15.375 8.63281 16.4688 7.5 17.25 7.5C17.9922 7.5 18.5 8.00781 18.5 8.75C18.5 9.53125 17.9922 10 17.25 10Z" fill="white"/></svg>'
  }
  if (el === 'Interior') {
    icon = '<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0.8125C4.64844 0.8125 0.3125 5.1875 0.3125 10.5C0.3125 15.8516 4.64844 20.1875 10 20.1875C15.3125 20.1875 19.6875 15.8516 19.6875 10.5C19.6875 5.1875 15.3125 0.8125 10 0.8125ZM10 3.3125C13.5156 3.3125 16.4453 5.89062 17.0703 9.25H13.3984C12.9688 8.50781 12.1484 8 11.25 8H8.75C7.8125 8 6.99219 8.50781 6.5625 9.25H2.89062C3.51562 5.89062 6.44531 3.3125 10 3.3125ZM2.89062 11.75H6.875L8.75 14.25V17.6094C5.78125 17.0625 3.4375 14.7188 2.89062 11.75ZM11.25 17.6094V14.25L13.125 11.75H17.0703C16.5234 14.7188 14.1797 17.0625 11.25 17.6094Z" fill="white"/></svg>'
  }
  if (el === 'Safety') {
    icon = '<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.2031 3.78125L10.7031 0.65625C10.5078 0.578125 10.1953 0.539062 10 0.539062C9.76562 0.539062 9.45312 0.578125 9.25781 0.65625L1.75781 3.78125C1.05469 4.09375 0.625 4.75781 0.625 5.5C0.625 13.2734 5.07812 18.625 9.25781 20.3828C9.72656 20.5781 10.2344 20.5781 10.7031 20.3828C14.0625 18.9766 19.375 14.1719 19.375 5.5C19.375 4.75781 18.9062 4.09375 18.2031 3.78125ZM16.3672 8.23438L9.17969 15.4219C8.94531 15.6953 8.51562 15.6953 8.28125 15.4219L4.21875 11.3594C3.98438 11.125 3.98438 10.7344 4.21875 10.5L5.11719 9.60156C5.35156 9.36719 5.74219 9.36719 5.97656 9.60156L8.75 12.3359L14.6094 6.47656C14.8438 6.24219 15.2344 6.24219 15.4688 6.47656L16.3672 7.375C16.6016 7.60938 16.6016 8 16.3672 8.23438Z" fill="white"/></svg>'
  }
  if (el === 'Electronics') {
    icon = '<svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.75 2.5H17.5V0.625C17.5 0.3125 17.1875 0 16.875 0H13.125C12.7734 0 12.5 0.3125 12.5 0.625V2.5H7.5V0.625C7.5 0.3125 7.1875 0 6.875 0H3.125C2.77344 0 2.5 0.3125 2.5 0.625V2.5H1.25C0.546875 2.5 0 3.08594 0 3.75V13.75C0 14.4531 0.546875 15 1.25 15H18.75C19.4141 15 20 14.4531 20 13.75V3.75C20 3.08594 19.4141 2.5 18.75 2.5ZM7.5 7.8125C7.5 8.00781 7.34375 8.125 7.1875 8.125H2.8125C2.61719 8.125 2.5 8.00781 2.5 7.8125V7.1875C2.5 7.03125 2.61719 6.875 2.8125 6.875H7.1875C7.34375 6.875 7.5 7.03125 7.5 7.1875V7.8125ZM17.5 7.8125C17.5 8.00781 17.3438 8.125 17.1875 8.125H15.625V9.6875C15.625 9.88281 15.4688 10 15.3125 10H14.6875C14.4922 10 14.375 9.88281 14.375 9.6875V8.125H12.8125C12.6172 8.125 12.5 8.00781 12.5 7.8125V7.1875C12.5 7.03125 12.6172 6.875 12.8125 6.875H14.375V5.3125C14.375 5.15625 14.4922 5 14.6875 5H15.3125C15.4688 5 15.625 5.15625 15.625 5.3125V6.875H17.1875C17.3438 6.875 17.5 7.03125 17.5 7.1875V7.8125Z" fill="white"/></svg>'
  }
  if (el === 'AudioVideo') {
    icon = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.3906 11.1562L9.14062 6.14062C8.39062 5.76562 7.5 6.28125 7.5 7.125V16.875C7.5 17.7656 8.39062 18.2812 9.14062 17.8594L17.3906 13.125C18.1875 12.7031 18.1875 11.625 17.3906 11.1562ZM23.625 12C23.625 5.57812 18.4219 0.375 12 0.375C5.57812 0.375 0.375 5.57812 0.375 12C0.375 18.4219 5.57812 23.625 12 23.625C18.4219 23.625 23.625 18.4219 23.625 12ZM2.625 12C2.625 6.84375 6.79688 2.625 12 2.625C17.1562 2.625 21.375 6.84375 21.375 12C21.375 17.2031 17.1562 21.375 12 21.375C6.79688 21.375 2.625 17.2031 2.625 12Z" fill="white"/></svg>'
  }

  return icon;
}

let mapStyle = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#212121"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#212121"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.locality",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#181818"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#1b1b1b"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#2c2c2c"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#8a8a8a"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#373737"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#3c3c3c"
      }
    ]
  },
  {
    "featureType": "road.highway.controlled_access",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#4e4e4e"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#000000"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#3d3d3d"
      }
    ]
  }
];

let location;

let rentDurationValue;
let mileageAmountValue;
let advancePaymentAmountValue;
let carID;

let priceVat;
// let rentDurationValue;


function carDataAjax(carElement) {
  let successCarAjax = false;

  let post_id = $(carElement).attr("data-id");
  if (typeof post_id == 'undefined') {
    return;
  }
  // console.log(post_id);
  const inputDuration = $('.input-steps-wrapper-duration');
  const inputRange = $('.input-steps-wrapper-range');
  const inputDownPaymentRange = $('.input-steps-custom-wrapper');

  const mileagePriceValue = document.getElementById('mileagePrice');
  const basePrice = document.getElementById('basePrice');
  let priceTotal = document.getElementById('price-total');

  let monthInput;
  let rangeInput;
  let downPaymentInput;

  $.ajax({
    type: 'POST',
    url: ajax_cars_data.ajaxurl,
    dataType: 'json',
    data: {
      'post_id': post_id,
      'action': 'car_data_pricing',
    },
    beforeSend: function () {
      $("#loaderDiv").fadeIn();
    },
    success: function (response) {

      $("#loaderDiv").fadeOut(1000);

      let car_pricing_array = response.pricing_array;

      document.querySelectorAll('.input-steps-wrapper-duration')[0].innerHTML = '';
      document.querySelectorAll('.input-steps-wrapper-range')[0].innerHTML = '';
      document.querySelectorAll('.input-steps-custom-wrapper')[0].innerHTML = '';

      const month_duration_length = car_pricing_array.length;

      $('.calculator-month-slider input[type="range"]').attr('max', month_duration_length);
      $('.calculator-month-slider input[type="range"]').attr('value', month_duration_length);

      for (let index = 0; index < car_pricing_array.length; index++) {
        const element = car_pricing_array[index].rent_duration_months;
        // inputDuration.append("<div class='input-step'><span>" + element + " mėn.</span></div>");
        inputDuration.append("<div class='input-step'><span>" + element + ' ' + js_object_name.month_string_dif + ".</span></div>");

      }

      inputStepsPosition();

      $('#duration').attr('max', car_pricing_array.length);
      $('input[type="range"]').rangeslider('destroy');
      let mileage_range_value;
      let down_payment_range_value;
      let month_duration_value;
      let mileage_range_value_array;
      let mileage_down_payment_array;
      let month_duration_down_payment;

      let monthBasePrice;

      let priceMilageTotal;

      let downInputValue;

      priceTotal.innerText = '';

      $('input[type="range"]').rangeslider({
        polyfill: false,

        onInit: function () {

          if (this.$element[0].id === 'duration') {

            month_duration_value = car_pricing_array[this.$element[0].defaultValue - 1];
            rentDurationValue = month_duration_value.rent_duration_months;
            monthBasePrice = month_duration_value.base_price;

            let month_duration_mileage_array = month_duration_value.mileage_options;
            let month_duration_down_payment_array = month_duration_value.down_payment_options;
            $('.calculator-mileage-slider input[type="range"]').attr('max', month_duration_mileage_array.length);
            $('.calculator-down-payment-slider input[type="range"]').attr('max', month_duration_down_payment_array.length);

            for (let index = 0; index < month_duration_mileage_array.length; index++) {
              const element = month_duration_mileage_array[index].mileage_option;
              inputRange.append("<div class='input-step'><span>" + element + " km</span></div>");
            }
            for (let index = 0; index < month_duration_down_payment_array.length; index++) {
              const element = month_duration_down_payment_array[index].down_payment_option;
              inputDownPaymentRange.append("<div class='input-step'><span>" + element + "€</span></div>");
            }
            monthInput = this.$element[0].defaultValue - 1;
          }

          if (this.$element[0].id === 'mileageRange') {
            mileage_range_value_array = month_duration_value.mileage_options;
            mileage_range_value = mileage_range_value_array[this.$element[0].defaultValue - 1];
            rangeInput = this.$element[0].defaultValue - 1;

            mileageAmountValue = mileage_range_value.mileage_option;

          }

          if (this.$element[0].id === 'downPaymentRange') {
            month_duration_down_payment = month_duration_value.pricing_down_payment;

            $('.calculator-down-payment-slider input[type="range"]').attr('value', month_duration_down_payment.length);

            down_payment_range_value = month_duration_down_payment[this.$element[0].defaultValue - 1];
            mileage_down_payment_array = down_payment_range_value.mileageprices;
            for (let elm of mileage_down_payment_array) {
              if (elm.mileage == mileage_range_value['mileage_option']) {
                // priceVat = elm.total_price_with_vat;
                priceVat = elm.total_price_with_vat;
                mileagePriceValue.innerText = parseInt(elm.mileage_price, 10);
              }
            }
            downPaymentInput = this.$element[0].defaultValue - 1;
            advancePaymentAmountValue = down_payment_range_value.downpayment;

          }

          priceTotal.innerText = priceVat;

          inputStepsPosition();

        },

        onSlideEnd: function (position, value) {


          if (this.$element[0].id === 'duration') {

            document.querySelectorAll('.input-steps-wrapper-range')[0].innerHTML = '';
            document.querySelectorAll('.input-steps-custom-wrapper')[0].innerHTML = '';
            month_duration_value = car_pricing_array[value - 1];
            monthBasePrice = parseInt(month_duration_value.base_price, 10);


            let month_duration_mileage_array = month_duration_value.mileage_options;
            let month_duration_down_payment_array = month_duration_value.down_payment_options;
            $('.calculator-mileage-slider input[type="range"]').attr('max', month_duration_mileage_array.length);
            $('.calculator-down-payment-slider input[type="range"]').attr('max', month_duration_down_payment_array.length);





            for (let index = 0; index < month_duration_mileage_array.length; index++) {
              const element = month_duration_mileage_array[index].mileage_option;
              inputRange.append("<div class='input-step'><span>" + element + " km</span></div>");
            }
            for (let index = 0; index < month_duration_down_payment_array.length; index++) {
              const element = month_duration_down_payment_array[index].down_payment_option;
              inputDownPaymentRange.append("<div class='input-step'><span>" + element + "€</span></div>");
            }


            inputStepsPosition();

            if (downInputValue > month_duration_down_payment_array.length) {
              downInputValue = month_duration_down_payment_array.length;
            }

            if (downInputValue) {
              downPaymentInput = downInputValue - 1;
            } else {
              downPaymentInput = month_duration_down_payment_array.length - 1;
            }

            let monthSlideDownPayment = month_duration_value.pricing_down_payment[downPaymentInput].mileageprices[rangeInput]['total_price_with_vat'];

            let monthSlideDownPaymentMileagePrice = month_duration_value.pricing_down_payment[downPaymentInput].mileageprices[rangeInput]['mileage_price'];
            mileagePriceValue.innerText = parseInt(monthSlideDownPaymentMileagePrice, 10);

            priceVat = monthSlideDownPayment;

            rentDurationValue = month_duration_value.rent_duration_months;

            $('#duration').attr('value', value);
            advancePaymentAmountValue = month_duration_value.pricing_down_payment[downPaymentInput].downpayment;

            mileageAmountValue = month_duration_value.mileage_options[rangeInput].mileage_option;
          }

          if (this.$element[0].id === 'mileageRange') {
            rangeInput = value - 1;
            let priceSlideMileage = month_duration_value.pricing_down_payment[downPaymentInput].mileageprices[rangeInput]['mileage_price'];
            mileagePriceValue.innerText = priceSlideMileage;
            mileageAmountValue = month_duration_value.pricing_down_payment[downPaymentInput].mileageprices[rangeInput].mileage;

            priceVat = month_duration_value.pricing_down_payment[downPaymentInput].mileageprices[rangeInput]['total_price_with_vat'];
            $('#mileageRange').attr('value', value);

          }

          if (this.$element[0].id === 'downPaymentRange') {
            downPaymentInput = value - 1;
            let priceSlideDownPayment = month_duration_value.pricing_down_payment[downPaymentInput].mileageprices[rangeInput]['total_price_with_vat'];
            priceVat = priceSlideDownPayment;
            $('#downPaymentRange').attr('value', value);

            downInputValue = value;

            advancePaymentAmountValue = month_duration_value.pricing_down_payment[downPaymentInput].downpayment;


          }

          $('input[type="range"]').rangeslider('update', true);

          priceTotal.innerText = priceVat;

        },
      });

      $('.single-hero-car-slider .swiper-wrapper').empty();
      let image_array = response.image_array;
      for (let index = 0; index < image_array.length; index++) {
        let element = image_array[index].additional_car_image;
        $('.single-hero-car-slider .swiper-wrapper').append("<div class='swiper-slide'><img src=" + element + "></div>");
      }

      singleCarSLider.update();

      // $('#modalConfiguration .configuration-block').html('');

      // let car_equipment_list_array = response.car_equipment_list_array;

      // for (let index = 0; index < car_equipment_list_array.length; index++) {
      //   let element = car_equipment_list_array[index].car_equipment_list_category;
      //   let elementBig = car_equipment_list_array[index].car_equipment_list_category_items;
      //   let catIcon = checkIcon(element);
      //   if(element == 'Exterior') {
      //     element = 'Eksterjeras';
      //   }
      //   if(element == 'Interior') {
      //     element = 'Interjeras';
      //   }
      //   if(element == 'Safety') {
      //     element = 'Eksterjeras';
      //   }
      //   if(element == 'Electronics') {
      //     element = 'Elektronika';
      //   }
      //   if(element == 'AudioVideo') {
      //     element = 'Garsas / Vaizdas';
      //   }
      //   let html = '<div class="category-block"><div class="cat-equip-title">' + catIcon + '<h5>' + element + '</h5></div><ul>'

      //   for (let index = 0; index < elementBig.length; index++) {
      //     let element = elementBig[index].car_equipment_list_category_item;
      //     html += '<li>' + element + '</li>';
      //   }

      //   html += '</ul></div>';

      //   $('#modalConfiguration .configuration-block').append( html );

      // }



      let locations = response.coordinates_array;
      let zoomLevel;
      if (locations.length == 1) {
        zoomLevel = 10;
      } else {
        zoomLevel = 7;
      }

      const map = new google.maps.Map(document.getElementById("map"), {
        zoom: zoomLevel,
        center: { lat: Number(locations[0].latitude), lng: Number(locations[0].longitude) },
        styles: mapStyle,
        disableDefaultUI: true,
        scrollwheel: false,
        clickableIcons: false,
        disableAutoPan: true,
      });

      const locationOrigin = window.location.origin;
      function setMarkers(map) {
        const image = {
          url: locationOrigin + "/wp-content/themes/mybee/public/images/mybee_pin.svg", // url
          size: new google.maps.Size(24, 24),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(0, 24),
          scaledSize: new google.maps.Size(24, 24)
        };

        for (let i = 0; i < locations.length; i++) {
          // const location = locations[i];
          const locationLat = Number(locations[i].latitude);
          const locationLong = Number(locations[i].longitude);
          new google.maps.Marker({
            position: { lat: locationLat, lng: locationLong },
            map,
            icon: image,
          });
        }
      }

      setMarkers(map);


    },
    error: function () {
      console.log('ajax fail');
    },
  });
}

function carSelect() {

  const car_select_first = document.querySelectorAll('.car-box-select');
  const car = car_select_first[0];
  const firstCar = $('.car-box-select.selected').first();
  // console.log

  function carData(el) {
    const date = el.dataset.date;
    const gearbox = el.dataset.gearbox;
    const powerKw = el.dataset.powerKw;
    const powerHp = el.dataset.powerHp;
    const capacity = el.dataset.capacity;
    const fuelType = el.dataset.fueltype;
    const emmision = el.dataset.emmision;
    const city = el.dataset.city;
    const pdfLink = el.dataset.pdf;
    const workingHours = el.dataset.workinghours;
    carID = el.dataset.carid;

    console.log(workingHours);

    var regex = /[;]/g;
    var str = workingHours;
    var subst = "$&</br>";
    var result = str.replace(regex, subst);
    console.log(result.substring(0, result.indexOf(' ')));

    $('.spec-data-date').html(date);
    $('.spec-data-gearbox').html(gearbox);
    $('.spec-data-capacity').html(capacity);
    $('.spec-data-power').html(powerKw + 'kw' + ' / ' + powerHp + 'Hp');
    $('.spec-data-fueltype').html(fuelType);
    $('.spec-data-emmision').html(emmision + 'g/km');
    $('.spec-data-city').html(city);
    if (pdfLink) {
      $('#configuration-btn-full').attr("href", pdfLink);
      $('#configuration-btn-full').css('display', 'flex');
      $('#configuration-btn-full-modal').attr("href", pdfLink);
      $('#configuration-btn-full-modal').css('display', 'flex');
    } else {
      $('#configuration-btn-full').css('display', 'none');
      $('#configuration-btn-full-modal').css('display', 'none');
    }
    $('.spec-data-working-hours').html(result.substring(0, result.indexOf(' ')) + '<br>' + result.substring(result.indexOf(' ') + 1));
  }

  if (typeof car !== 'undefined') {
    carData(car);
  }


  $('.car-box-select').on('click', function () {
    $(".car-box-select").removeClass('selected');
    $(this).addClass('selected');
    const selectedCar = $(this)[0];

    if (typeof selectedCar !== 'undefined') {
      carData(selectedCar);
    }

    let thisCar = $(this);
    carDataAjax(thisCar);

    $('html,body').animate({
      scrollTop: $(".section-cars-terms").offset().top
    },
      500);
    $('.calculator-element').css({ 'position': 'relative', 'top': '0' });
    $('.checkout-services').css({ 'right': '-100%', 'display': 'none' });
    $('.additional-services').css({ 'right': '-100%', 'display': 'none' });
    $('.back-btn').fadeOut();
    $('.terms-page').fadeOut();
    $('#btnModal').fadeOut();
    $('#btnCalc').show();
    $('.calculator-footer-left-label, .calculator-footer-left-price').fadeIn();
    $('#btnCalc').removeClass('checkout-btn checkout-modal').addClass('next-btn-services');
    $('.back-btn').removeClass('calc-back-btn services-back-btn');

    equipment_list();


  });

  setTimeout(() => {
    if (firstCar) {
      if (firstCar[0]) {
        carData(firstCar[0]);
      }

      carDataAjax(firstCar);
    }
  }, 300);

  equipment_list();


}

function checkInputLength() {

  $(".form-input input").focus(function () {
    $(this).parent().siblings('label').addClass('active-text');
  })
    .blur(function () {
      let text_val = $(this).val();
      if (text_val === "") {
        $(this).parent().siblings('label').removeClass('active-text');
      }
    });

}

function contactFormSucess() {
  const input = document.querySelector(`input[name="radio-rent-duration"]`);

  $('.wpcf7-list-item-label').on('click', function () {
    let button = $(this).closest('form').find('input[type=submit]');
    if ($(this).parent().parent().hasClass('last')) {
      $(button).addClass('open-rent-modal')
    } else {
      $(button).removeClass('open-rent-modal')
    }
  });

  const modalRentDuration = document.getElementById("modalRentDuration");

  if (typeof modalRentDuration == 'undefined') {
    return;
  }

  const body = document.getElementsByTagName('body')[0]



  $('input[type=submit').on('click', function (e) {
    if ($(this).hasClass('open-rent-modal')) {
      e.preventDefault();
      modalRentDuration.style.display = "flex";
      body.style.overflow = "hidden";
      $('.header').css('z-index', '0');
      $('.nav-primary').removeClass('open');
      $('body').removeClass('opened');

      return false;
    } else {
    };
  });
  document.addEventListener('wpcf7mailsent', function (event) {
    $('.form-input label').removeClass('active-text');
    $('.heading-wrap').fadeOut(100);

    $('.form-box, .contact-form').fadeOut(100).promise().done(function () {
      $('.form-box-success').fadeIn(100);
    });



  }, false);
}


function googleMaps() {
  let icon = {
    url: "../../wp-content/themes/mybee/resources/images/mybee_pin.svg", // url
    scaledSize: new google.maps.Size(24, 24),
    // anchor: new google.maps.Point(20, 20),
  };

  const vilniusLocation = { lat: 54.68729141651558, lng: 25.277414283132337 };

  if (document.getElementById("map")) {
    const map = new google.maps.Map(document.getElementById("map"), {
      zoom: 4,
      center: vilniusLocation,
      styles: mapStyle,
      disableDefaultUI: true,
      streetViewControl: false,
      scrollwheel: false,
      clickableIcons: false,
      disableAutoPan: true,
    });

    // The marker, positioned at Uluru
    const marker = new google.maps.Marker({
      position: vilniusLocation,
      icon: icon,
      map: map,
    });
  }

  // The map, centered at Uluru

}

function equipment_list() {
  if (typeof carID == 'undefined') {
    return;
  }

  $.ajax({
    type: 'POST',
    url: ajax_cars_data.ajaxurl,
    dataType: 'json',
    data: {
      'car_id': carID,
      'action': 'car_equipment_list',
    },
    beforeSend: function () {
      // $("#serviceloaderDiv").fadeIn();
    },
    success: function (response) {

      $('#modalConfiguration .configuration-block').html('');

      let car_equipment_list_array = response.car_equipment_list_response_decoded;


      // console.log(car_equipment_list_array);

      Object.keys(car_equipment_list_array).forEach(function (k) {
        // console.log(k, car_equipment_list_array[k]);

        // for (let index = 0; index < car_equipment_list_array[k].length; index++) {
        let element = k;
        // let elementBig = car_equipment_list_array[k];
        // console.log(elementBig);
        let catIcon = checkIcon(element);
        if (element == 'Exterior') {
          element = js_object_name.exterior_string;
        }
        if (element == 'Interior') {
          element = js_object_name.interior_string;
        }
        if (element == 'Safety') {
          element = js_object_name.safety_string;
        }
        if (element == 'Electronics') {
          element = js_object_name.electronics_string;
        }
        if (element == 'AudioVideo') {
          element = js_object_name.audioVideo_string;
        }
        let html = '<div class="category-block"><div class="cat-equip-title">' + catIcon + '<h5>' + element + '</h5></div><ul>'

        car_equipment_list_array[k].forEach(element => {
          html += '<li>' + element + '</li>';
        });

        // for (let index = 0; index < elementBig.length; index++) {
        //   let element = elementBig[index].car_equipment_list_category_item;

        // }

        html += '</ul></div>';

        $('#modalConfiguration .configuration-block').append(html);

        // }
      });


    }
  });
}

let dataFormCheckbox = '';
let benefits = [];

function additionalServices() {
  let insuranceTotal;
  let checkoutTotalMonthly;
  let checkoutMonthlyRent;
  let checkoutMonthlyRide;
  let additionalMonthlyTotal;
  let contractFee;
  let deliveryFee;

  $('.form-selection--item').on('click', function () {
    $('.form-selection--item').removeClass('selected');
    $(this).toggleClass('selected');
  });



  $('#btnCalc').on('click', function () {
    $(this).addClass('disabled');

    $('.progress.current').next().addClass('current').prev().removeClass('current').addClass('completed');

    let btnCurrentIndex = parseInt($('#btnCalc').attr('data-index-btn'), 10);
    let currentScreenStep;
    if ($('.form-selection--item--juridical').hasClass('selected')) {
      currentScreenStep = $(this).attr('data-index-btn', btnCurrentIndex + 2);
    } else {
      currentScreenStep = $(this).attr('data-index-btn', btnCurrentIndex + 1);
    }


    $.ajax({
      type: 'POST',
      url: ajax_cars_data.ajaxurl,
      dataType: 'json',
      data: {
        'car_id': carID,
        'rent_duration': rentDurationValue,
        'mileage_amount': mileageAmountValue,
        'advance_payment': advancePaymentAmountValue,
        'action': 'car_data_benefits',
      },
      beforeSend: function () {
        $("#serviceloaderDiv").fadeIn();
      },
      success: function (response) {
        $("#serviceloaderDiv").fadeOut();

        let car_benefits_obj = response.car_benefits_response_decoded;

        $('.additional-services').html('');
        let html = '';
        let html_insurance = '';

        for (let index = 0; index < car_benefits_obj.length; index++) {
          let element = car_benefits_obj[index];
          //  insuranceElement;
          let requiredCheckbox = '';
          let IsOneTimeBenefit = '';
          let pricing = '';
          let disabledCheckbox = '';

          if (element.IsMandatory == true) {
            requiredCheckbox = 'checked';
            disabledCheckbox = ' disabled';
          }
          if (element.IsOneTimeBenefit == true) {
            IsOneTimeBenefit = 'singlePayment';
            pricing = ' €';
          } else {
            IsOneTimeBenefit = 'monthlyPayment';
            pricing = '€/ ' + js_object_name.month_string + '';
            // pricing = ' €/mėn';
          }

          if (element.IsInsurance !== true) {

            html += '<div class="benefit-element benefit-element-basic" data-description="' + element.Description + '" data-payment-duration="' + IsOneTimeBenefit + '">';
            html += '<div class="benefit-title" data-benefit-id="' + element.Id + '" >' + element.Value + '</div>';
            html += '<div class="benefit-content">';
            html += '<div class="benefit-price">' + element.Price + pricing + '</div>';
            html += '<div><i class="tooltip"><svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 0.96875C3.13306 0.96875 0 4.13004 0 7.96875C0 11.8357 3.13306 14.9688 7 14.9688C10.8387 14.9688 14 11.8357 14 7.96875C14 4.13004 10.8387 0.96875 7 0.96875ZM7 4.07359C7.64919 4.07359 8.18548 4.60988 8.18548 5.25907C8.18548 5.93649 7.64919 6.44456 7 6.44456C6.32258 6.44456 5.81452 5.93649 5.81452 5.25907C5.81452 4.60988 6.32258 4.07359 7 4.07359ZM8.58064 11.2429C8.58064 11.4405 8.41129 11.5817 8.24193 11.5817H5.75806C5.56048 11.5817 5.41935 11.4405 5.41935 11.2429V10.5655C5.41935 10.3962 5.56048 10.2268 5.75806 10.2268H6.09677V8.42036H5.75806C5.56048 8.42036 5.41935 8.27923 5.41935 8.08165V7.40423C5.41935 7.23488 5.56048 7.06552 5.75806 7.06552H7.56452C7.73387 7.06552 7.90323 7.23488 7.90323 7.40423V10.2268H8.24193C8.41129 10.2268 8.58064 10.3962 8.58064 10.5655V11.2429Z" fill="#93939D"/></svg></i></div>';
            html += '<div class="checkbox-wrap">';
            html += '<input class="ios-input-checkbox" type="checkbox" id="benefit_id_' + element.Id + '"' + requiredCheckbox + disabledCheckbox + '>';
            html += '<label class="ios-label-checkbox" for="benefit_id_' + element.Id + '"></label>';
            html += '</div>';
            html += '</div>';
            html += '</div>';
          } else {
            html_insurance += '<div class="benefit-element" data-description="' + element.Description + '" data-payment-duration="' + IsOneTimeBenefit + '">';
            html_insurance += '<div class="benefit-title" data-benefit-id="' + element.Id + '" >' + element.Value + '</div>';
            html_insurance += '<div class="benefit-content">';
            html_insurance += '<div class="benefit-price"><span>' + element.Price + '</span>' + pricing + '</div>';
            html_insurance += '<div><i class="tooltip"><svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 0.96875C3.13306 0.96875 0 4.13004 0 7.96875C0 11.8357 3.13306 14.9688 7 14.9688C10.8387 14.9688 14 11.8357 14 7.96875C14 4.13004 10.8387 0.96875 7 0.96875ZM7 4.07359C7.64919 4.07359 8.18548 4.60988 8.18548 5.25907C8.18548 5.93649 7.64919 6.44456 7 6.44456C6.32258 6.44456 5.81452 5.93649 5.81452 5.25907C5.81452 4.60988 6.32258 4.07359 7 4.07359ZM8.58064 11.2429C8.58064 11.4405 8.41129 11.5817 8.24193 11.5817H5.75806C5.56048 11.5817 5.41935 11.4405 5.41935 11.2429V10.5655C5.41935 10.3962 5.56048 10.2268 5.75806 10.2268H6.09677V8.42036H5.75806C5.56048 8.42036 5.41935 8.27923 5.41935 8.08165V7.40423C5.41935 7.23488 5.56048 7.06552 5.75806 7.06552H7.56452C7.73387 7.06552 7.90323 7.23488 7.90323 7.40423V10.2268H8.24193C8.41129 10.2268 8.58064 10.3962 8.58064 10.5655V11.2429Z" fill="#93939D"/></svg></i></div>';
            html_insurance += '<div class="checkbox-wrap">';
            html_insurance += '<input class="ios-input-checkbox" type="checkbox" id="benefit_id_' + element.Id + '"' + requiredCheckbox + disabledCheckbox + '>';
            html_insurance += '<label class="ios-label-checkbox" for="benefit_id_' + element.Id + '"></label>';
            html_insurance += '</div>';
            html_insurance += '</div>';
            html_insurance += '</div>';
          }
        }


        $('.additional-services').append(html);
        $('.benefit-element').last().after('<div class="benefet-insurance-wrapper"><div class="insurance-title">' + js_object_name.insurance_string + '</div>' + html_insurance + '</div>');

        tooltipDescription();
        benefits = [];
        if ($(currentScreenStep).attr('data-index-btn') === '1') {
          $('.checkout-services').css({ 'right': '-100%', 'display': 'none' });
          $('.additional-services').css({ 'right': '0', 'display': 'flex' });
          $('.calculator-element').css({ 'position': 'absolute', 'top': '-100%' });
          $('.back-btn').fadeIn();


          $('#btnCalc').fadeOut().promise().done(function () {
            $('#trigger-send').css("display", "flex").hide().fadeIn();
          });

        } else {
          $('.additional-services').css({ 'right': '-100%', 'display': 'none' });
          $('.checkout-services').css({ 'right': '0', 'display': 'flex' });
          benefits = [];

        }

        $('#btnCalc').removeClass('disabled');

      },
      error: function () {
        console.log('ajax fail');
      },
    });


    checkoutMonthlyRide = $('#mileagePrice').text();
    checkoutMonthlyRent = priceVat - checkoutMonthlyRide;


    insuranceTotal = 0;
    $('.benefet-insurance-wrapper .ios-input-checkbox:checked').each(function () {
      let insuranceMonthlyString = $(this).parent().parent().find('.benefit-price span')[0].innerHTML;
      let insuranceMonthly = Number(insuranceMonthlyString.replace(/[^\d.-]/g, ''));
      insuranceTotal += insuranceMonthly;
      return insuranceTotal;
    });

    additionalMonthlyTotal = 0;
    $('.benefit-element-basic:not([data-payment-duration="singlePayment"]) .ios-input-checkbox:checked').each(function () {
      let additionalMonthlyString = $(this).parent().parent().find('.benefit-price')[0].innerHTML;
      let additionalMonthly = Number(additionalMonthlyString.replace(/[^\d.-]/g, ''));
      additionalMonthlyTotal += additionalMonthly;
      return additionalMonthlyTotal;
    });

    checkoutTotalMonthly = (checkoutMonthlyRent + insuranceTotal + additionalMonthlyTotal + Number(checkoutMonthlyRide)).toFixed(2);

    $('.benefit-element-basic[data-payment-duration="singlePayment"] .ios-input-checkbox:disabled').each(function () {
      let contractFeeString = $(this).parent().parent().find('.benefit-price')[0].innerHTML;
      contractFee = Number(contractFeeString.replace(/[^\d.-]/g, ''));
      return contractFee;
    });

    deliveryFee = 0;
    $('.benefit-element-basic[data-payment-duration="singlePayment"] .ios-input-checkbox:checked').not(':disabled').each(function () {
      let deliveryFeeString = $(this).parent().parent().find('.benefit-price')[0].innerHTML;
      deliveryFee = Number(deliveryFeeString.replace(/[^\d.-]/g, ''));
      return deliveryFee;
    });

    let totalOneTime = parseInt(Number(advancePaymentAmountValue) + deliveryFee + contractFee, 10);

    $('.total-monthly').empty().append(checkoutTotalMonthly + ' €/' + js_object_name.month_string + '');
    $('.list-price-rent').empty().append(checkoutMonthlyRent.toFixed(2) + ' €/' + js_object_name.month_string + '');
    $('.list-price-mileage').empty().append(checkoutMonthlyRide + ' €/' + js_object_name.month_string + '');
    $('.list-price-insurance').empty().append(insuranceTotal + ' €/' + js_object_name.month_string + '');
    $('.list-price-additional').empty().append(additionalMonthlyTotal + ' €/' + js_object_name.month_string + '');


    $('.total-one-time').empty().append(totalOneTime + ' €');
    $('.list-price-advance').empty().append(advancePaymentAmountValue + ' €');
    $('.list-price-delivery').empty().append(deliveryFee + ' €');
    $('.list-price-contract').empty().append(contractFee + ' €');



    // $('.benefit-element .ios-input-checkbox:checked').each(function () {
    //   let dataFormCheckbox = $(this).parent().parent().parent().find('.benefit-title');
    //   let dataFormCheckboxId = dataFormCheckbox.attr('data-benefit-id');
    //   benefits.push(+dataFormCheckboxId);
    // });

  });


  $(document).on("click", "#trigger-send", function () {
    benefits = [];
    $('.benefit-element .ios-input-checkbox:checked').each(function () {
      let dataFormCheckbox = $(this).parent().parent().parent().find('.benefit-title');
      let dataFormCheckboxId = dataFormCheckbox.attr('data-benefit-id');
      benefits.push(+dataFormCheckboxId);
    });
    carDataForm();
    $('.form-selection--juridical .form-submit-input input').trigger('click');
  });
  $(document).on("click", ".back-btn", function () {
    $('.progress.current').prev().removeClass('completed').addClass('current').next().removeClass('current');

    let btnCurrentIndex = parseInt($('#btnCalc').attr('data-index-btn'), 10);
    let currentScreenStep;
    if ($('.form-selection--item--juridical').hasClass('selected')) {
      currentScreenStep = $('#btnCalc').attr('data-index-btn', btnCurrentIndex - 2);
    } else {
      currentScreenStep = $('#btnCalc').attr('data-index-btn', btnCurrentIndex - 1);
    }

    if ($(currentScreenStep).attr('data-index-btn') === '1') {
      $('.additional-services').css({ 'right': '0', 'display': 'flex' });
      $('.checkout-services').css({ 'right': '-100%', 'display': 'none' });
      $('.back-btn').fadeIn();
      $('.calculator-footer-price').fadeIn();
      benefits = [];

      // $('#trigger-send').fadeOut().promise().done(function () {
      //   $('#btnCalc').css("display", "flex").hide().fadeIn();
      // });
    } else {
      $('#trigger-send').fadeOut().promise().done(function () {
        $('#btnCalc').css("display", "flex").hide().fadeIn();
      });
      $('.calculator-element').css({ 'position': 'relative', 'top': '0' })
      $('.additional-services').css({ 'right': '-100%', 'display': 'none' });
      $('.back-btn').fadeOut();
      benefits = [];

    }

  });


}

function tooltipDescription() {
  $('.tooltip').on('click', function (e) {
    e.stopPropagation();
    let tooltipText = $(this).parent().parent().parent().attr('data-description');
    $('.tooltip-modal p').empty().html(tooltipText);
    $('.tooltip-modal').css('display', 'flex');
    $('body').addClass('opened');
  });

  $('.tooltip-modal .tooltip-close').on('click', function () {
    $('.tooltip-modal').fadeOut();
    $('body').removeClass('opened');
  });

  $('.car-box-title .tooltip').on('click', function (e) {
    e.preventDefault();
  });
}

function carDataForm() {

  let formData = '';

  const selectedCarId = $('.car-box-select.selected')[0];

  if (typeof selectedCarId == 'undefined') {
    return;
  }

  let selectedCarModelMake = selectedCarId.querySelector('.car-box-title').innerText;

  formData += 'Automobilio ID: ' + selectedCarId.dataset.carid + '\n';
  formData += 'Automobilio Marke ir modelis:' + selectedCarModelMake + '\n';
  formData += 'Automobilio Kuro tipas: ' + selectedCarId.dataset.fueltype + '\n';
  formData += 'Automobilio Pavaru deze: ' + selectedCarId.dataset.gearbox + '\n';
  formData += 'Automobilio galia(Hp): ' + selectedCarId.dataset.powerHp + '\n';
  formData += 'Automobilio galia(Kw): ' + selectedCarId.dataset.powerKw + '\n';
  formData += 'Automobilio CO2: ' + selectedCarId.dataset.emmision + '\n';
  formData += 'Automobilio Talpa: ' + selectedCarId.dataset.capacity + '\n';
  formData += 'Automobilio Miestas: ' + selectedCarId.dataset.city + '\n';
  formData += ' \n';
  formData += 'Nuomos informacija \n';
  formData += 'Automobilio rida: ' + rentDurationValue + '\n';
  formData += 'Automobilio kilometrazas: ' + mileageAmountValue + '\n';
  formData += 'Automobilio avansas: ' + advancePaymentAmountValue + '\n';
  formData += ' \n';
  formData += 'Papildomos paslaugos \n';
  formData += dataFormCheckbox;

  $("#form-car-model-selected").val(formData);

  let carInfo = {
    'carId': +selectedCarId.dataset.carid,
    'rentDurationMonths': +rentDurationValue,
    'mileageAmount': +mileageAmountValue,
    'advancePaymentAmount': +advancePaymentAmountValue,
    'selectedAdditionalBenefits': benefits
  };
  let encodedCarInfo = btoa(JSON.stringify(carInfo));

  // console.log(carInfo);
  // console.log('https://app.mybee.lv/#/main/cars/rent-data?data=' + encodedCarInfo + '');
  window.location.href = 'https://app.mybee.lv/#/main/cars/rent-data?data=' + encodedCarInfo + '';

}

let footerLangs = () => {
  let footerButton = $('.footer__langs__active');
  let footerLangs = $('.footer__langs__submenu');

  $(document).click(function () {
    closeLangs();
  });

  let closeLangs = () => {
    footerButton.removeClass('is-active');
    footerButton.attr('aria-expanded', 'false');
    footerLangs.removeClass('is-active');
    footerLangs.attr('aria-hidden', 'true');
  }

  let openLangs = () => {
    footerButton.addClass('is-active');
    footerButton.attr('aria-expanded', 'true');
    footerLangs.addClass('is-active');
    footerLangs.attr('aria-hidden', 'false');
  }

  footerButton.click(function (e) {
    e.stopPropagation();

    if ($(this).hasClass('is-active')) {
      closeLangs()
    } else {
      openLangs();
    }
  })
}

let rentBtn = () => {
  $('#rent-btn-mobile').on('click', function () {
    $('body').toggleClass('opened-rent');
    $('.calculator-wrapper').fadeIn();
    setTimeout(() => {
      inputStepsPosition();
    }, 200);
  });

  $('.rent-heading .close').on('click', function () {
    $('body').toggleClass('opened-rent');
    $('.calculator-wrapper').fadeOut();
  });
}
